import { Col, Row } from 'react-bootstrap';
import GenericButton from 'src/Admin/components/common/button';
import { EditPencilSquareIcon } from 'src/Admin/img/Admin/approvalsIcon/approvals';
import { useSelector } from 'react-redux';
import { ParaRegular } from 'src/Admin/components/common/typography/ParaRegular';

export const SectionTitle = ({ title, subTitle }) => {
  const { themeValuesObject } = useSelector(({ theme }) => theme) || {};

  return (
    <Row className="section-title">
      <Col className="d-flex justify-content-between align-items-center">
        <div>
          <h5 className="block-title m-0">{title}</h5>
          {subTitle && <ParaRegular variant={'large'}>{subTitle}</ParaRegular>}
        </div>
        <GenericButton variant="secondary" className="height-32">
          <div className="d-flex align-items-center">
            <EditPencilSquareIcon
              fillColor={themeValuesObject['Primary-1']}
              className={'mr-1 mb-1'}
            />
            Edit
          </div>
        </GenericButton>
      </Col>
    </Row>
  );
};
